import { Button } from "@mui/material";
import React, { memo } from "react";

const Modal = ({ children, onClose, onSave, formik, isEdit, }) => {
  return (
    <div className="bg-white p-3 my-2">
      {children}
      <div className="flex justify-end py-2">
        <Button
          variant="outlined"
          onClick={() => {
            onClose(false);
            formik.resetForm();
          }}
        >
          Cancel
        </Button>
        <Button variant="contained" onClick={onSave} sx={{ marginInline: 2 }}>{isEdit ? 'Update' : 'Save'}</Button>
      </div>
    </div>
  );
};

export default memo(Modal);
